import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import AuthView from 'components/AuthView';
import { updateDocumentTitle } from 'actions';
import { getDefaultPageSize } from 'components/Pagination/PageSizeSelect';
import { convertToUTC } from 'helpers/time-handler';
import Filter, {
    getDefaultPeriod,
    KEYWORD,
    EXPENSE_TYPE,
    STATUS,
    CREATE_TIME
} from './Filter';
import List from './List';
import { useGetLinkpaysListQuery } from 'redux/hook/useLinkPay';

import './nonuser-charge.scss';



const NonUserCharge = () => {
    const getQueryString = useCallback((payload) => {
        const { filter, ...params } = payload;
        const { create_from, create_to} = filter;
        const { start, end } = getDefaultPeriod();
        return {
            ...filter,
            create_from: convertToUTC(create_from ? create_from : start),
            create_to: convertToUTC(create_to ? create_to : end) ,
            ...params
        };
    },[]);

    const location = useLocation();
    const dispatch = useDispatch();
    const i18n = useSelector(state => state.i18n);
    const { start } = getDefaultPeriod();
    const [keyword, setKeyword] = useState();
    const [queryPayload, setQueryPayload] = useState({
        filter: {
            [KEYWORD]: undefined,
            [EXPENSE_TYPE]: undefined,
            [STATUS]: undefined,
            create_from: undefined,
            create_to: undefined,
        },
        sort: undefined,
        size: getDefaultPageSize().value,
        page: 1,
    });
    const [appliedDateRange, setAppliedDateRange] = useState(false);
    const [fromTime, setFromTime] = useState(moment(start));
    const [toTime, setToTime] = useState(moment());
    const [pollingInterval, setPollingInterval] = useState(60000);

    const [queryString, setQueryString] = useState(getQueryString(queryPayload));

    useEffect(() => { }, [i18n]);

    useEffect(() => {
        const newQueryString = getQueryString(queryPayload);
        setQueryString(newQueryString);
    },[queryPayload, getQueryString]);

    const {
        data,
        refetch: getLinkpays,
    } = useGetLinkpaysListQuery(queryString, {
        pollingInterval,
    });

    useEffect(() => {
        const { pathname } = location;
        dispatch(updateDocumentTitle(`routes.${ pathname }`));
        // eslint-disable-next-line
    }, []);

    const setFromAndToTime = (filter = queryPayload.filter) => {
        const { create_from, create_to } = filter;
        setFromTime(create_from ? undefined : start);
        setToTime(create_to ? undefined : moment());
    };
    const handleApplyFilter = type => value => {
        let { filter } = queryPayload;

        switch (type) {
        case KEYWORD:
            const keyword = value === '' ? undefined : value;
            filter = {
                [KEYWORD]: keyword,
            };
            setKeyword(keyword)
            setAppliedDateRange(false);
            break;
        case CREATE_TIME:
            const { from, to } = value;
            filter.create_from = from;
            filter.create_to = to;

            setAppliedDateRange(!!(from && to));
            break;
        case STATUS:
        case EXPENSE_TYPE:
            filter[type] = value.inputSelect;
            break;
        default:
            filter[type] = value;
        }
        setFromAndToTime(filter);
        setQueryPayload({
            ...queryPayload,
            filter,
            page: 1,
        });

    };

    const handlePageSelect = page => {
        setFromAndToTime();
        setQueryPayload({
            ...queryPayload,
            page: page,
        });
    };

    const handlePageSizeChange = pageSize => {
        setFromAndToTime();
        setQueryPayload({
            ...queryPayload,
            page: 1,
            size: pageSize,
        });
    }

    const handleSort = ({ field, order }) => {
        setFromAndToTime();
        setQueryPayload({
            ...queryPayload,
            page: 1,
            sort: (field && order) ? `${field},${order}` : undefined,
        });

    };

    const fetchLinkpaysList = useCallback(() => {
        getLinkpays(queryString);
    },[getLinkpays, queryString]);

    useEffect(() => {
        fetchLinkpaysList();
    },[queryString, fetchLinkpaysList]);

    return (
        <AuthView className="nonuser-charge">
            <Filter
                applyFilter={ handleApplyFilter }
                value={ keyword }
                onChangeKeyword={ setKeyword }
                appliedDateRange={ appliedDateRange }
                filter={ queryPayload.filter }
            />
            <List
                onSort={ handleSort }
                onSelect={ handlePageSelect }
                onFetch={ fetchLinkpaysList }
                onChange={ handlePageSizeChange }
                onModalOpen={ (value) => setPollingInterval(value) }
                pageSize={ queryPayload.size }
                fromTime={ fromTime }
                toTime={ toTime }
                data={ data }
            />
        </AuthView>
    );
};

export default NonUserCharge;
